import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import {SectionTitle} from "../components/SectionTitle";
import Header from "../components/Header";
import BlogCard from "../components/BlogCard";
import { Pagination } from '@mui/material';
import { theme } from "../Template";
import { useCompanyData } from "../../shared/contexts/DataContext";

const Blog = () => {
  const { data } = useCompanyData();

  return (
    <div>
      <BlogHeader image={data.companyData?.avatar} />
      <BlogList />
    </div>
  );
};

const BlogHeader = ({ image }) => {
  return (
    <Header image={image}>
      <div>
        <Box pb={7}>
          <Typography
            variant="h2"
            style={{ color: "white", fontWeight: "bold" }}
          >
            Our Blog
          </Typography>
        </Box>

        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography variant="subtitle1" style={{ color: "#fafafa" }}>
            Home <span style={{ color: "#FAC400" }}>• Blog</span>
          </Typography>
        </Box>
      </div>
    </Header>
  );
};

const BlogList = () => {
  const matches = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box py={5} width="90%" m="auto">
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <SectionTitle>Our Blog</SectionTitle>
      </Box>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent={matches ? "space-between" : "center"}
      >
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
        <BlogCard />
      </Box>
      <Box py={4} display="flex" justifyContent="center">
        <Pagination
          shape="rounded"
          variant="outlined"
          size="large"
          color="primary"
          count={10}
        />
      </Box>
    </Box>
  );
};

export default Blog;
